import { Validator } from '@vista-digital/validator';
export const defaultLanguage = {
    languageTag: 'en',
    label: 'English',
    iconName: 'united-kingdom-flag',
    isDefault: true
};
export const languageValidator = Validator.object({
    iconName: Validator.nonEmptyString,
    languageTag: Validator.nonEmptyString,
    label: Validator.nonEmptyString,
    isDefault: Validator.boolean()
});
//# sourceMappingURL=language.js.map